import component from "./ScoreTableRow";

export default component;
